<template>
  <a-drawer
    :title="dramaDetail.name"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 视频版本 -->
      <a-form-item
        label="视频版本"
        name="type"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.type"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in YoutubeVideoTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
  
      <!-- 原语种 -->
      <a-form-item
        label="原语种"
      >
        <a-select
          v-model:value="formState.lang_id"
          placeholder="请选择"
          :disabled="true"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <!-- 目标语种 -->
      <a-form-item
        label="目标语种"
        name="target_lang_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.target_lang_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 翻译方式 -->
      <a-form-item label="翻译方式">
        <a-form-item-rest>
          <a-checkbox v-model:checked="formState.isSubtitle" disabled style="margin-right: 16px">字幕翻译</a-checkbox>
          <a-checkbox v-model:checked="formState.isVoice" @change="handleVoiceChange" style="margin-right: 16px">语音翻译</a-checkbox>
          <a-checkbox v-model:checked="formState.isFacial" @change="handleFacialChange" style="margin-right: 16px">面容翻译</a-checkbox>
        </a-form-item-rest>
      </a-form-item>

      <!-- 字幕来源 -->
      <a-form-item
        label="字幕来源"
        name="recognition_type"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-radio-group v-model:value="formState.recognition_type">
          <a-radio
            v-for="item in SubtitleSourceTypes"
            :key="item.value"
            :value="item.value"
            style="margin-right: 16px"
          >
            {{ item.text }}
          </a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- 音色设置 -->
      <a-form-item
        label="音色设置"
        name="speech_type"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-radio-group v-model:value="formState.speech_type" @change="onSpeechTypeChange">
          <a-radio
            v-for="item in SpeechTypes"
            :key="item.value"
            :value="item.value"
            style="margin-right: 16px"
          >
            {{ item.text }}
          </a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- 指定音色（仅单音色时显示） -->
      <a-form-item
        v-if="formState.speech_type === 2"
        label="指定音色"
        name="speech_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.speech_id"
          placeholder="请选择"
          allow-clear
          style="width: 200px; margin-right: 8px"
          @change="onSpeechIdChange"
        >
          <a-select-option
            v-for="item in speechList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a v-if="selectedSpeechUrl" class="timbre-preview-link" @click="touchPlayOrStop(selectedSpeechUrl)">
          {{ playingUrl === selectedSpeechUrl ? '停止' : '试听' }}
        </a>
      </a-form-item>

      <!-- 开启硬字幕 -->
      <a-form-item
        label="开启硬字幕"
        name="hard_subtitle_status"
      >
        <a-switch v-model:checked="formState.hard_subtitle_status" checked-children="开" un-checked-children="关" />
        <span style="color: #999; font-size: 13px; margin-left: 10px;">字号默认 30</span>
      </a-form-item>

      <!-- 擦除原字幕 -->
      <a-form-item
        label="擦除原字幕"
        name="erase_subtitle_status"
      >
        <a-switch v-model:checked="formState.erase_subtitle_status" checked-children="开" un-checked-children="关" />
      </a-form-item>
      
      <!-- 保留BGM -->
      <!-- <a-form-item
        label="保留BGM"
        name="bgm_status"
      >
        <a-switch v-model:checked="formState.bgm_status" checked-children="开" un-checked-children="关" />
      </a-form-item> -->
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>

  <!-- 二次确认弹窗 -->
  <a-modal
    v-model:visible="confirmVisible"
    title="提示"
    :maskClosable="false"
    :footer="null"
  >
    <div>任务创建后不可撤销！请再次确认任务设置是否正确！</div>
    <div style="text-align: right; margin-top: 16px;">
      <a-button style="margin-right: 8px" @click="handleConfirmCancel">取消</a-button>
      <a-button
        type="primary"
        :disabled="confirmOkDisabled"
        @click="handleConfirmOk"
      >
        {{ confirmOkDisabled ? `确定（${confirmCountdown}s）` : '确定' }}
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { reactive, ref, nextTick, computed } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { YoutubeVideoTypes, TranslationTypes, SubtitleSourceTypes, VideoTranslationType, SpeechTypes } from '@/utils/constantList'
import { message, Modal } from 'ant-design-vue'
import dayjs from 'dayjs'
// 引入 API
import { taskCheck, taskSave, langSearchList, accountAll, speechAll } from '@/api/admin'
import { dramaAdd } from '../../../../api/admin'

// emit
const emit = defineEmits(['success'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 语种列表
let languages = ref([])
// 发布账号列表
let publishingAccountList = ref([])
// 音色列表（speechAll 返回 id name url）
let speechList = ref([])
// 剧集详情
let dramaDetail = ref({})
// 试听：同一时间只允许一个播放，切换音色会先停止
let audioInstance = ref(null)
let playingUrl = ref(null)

// 二次确认弹窗相关
let confirmVisible = ref(false)
let confirmCountdown = ref(5)
let confirmOkDisabled = ref(true)
let confirmTimer = null
let pendingParams = ref(null)

// 表单参数
const formState = ref({
  // 视频版本
  type: undefined,
  // 原语种
  lang_id: undefined,
  // 目标语种
  target_lang_id: undefined,
  // 翻译方式
  // translation_type_list: [VideoTranslationType.subtitle, VideoTranslationType.voice],
  isSubtitle: true,
  isVoice: true,
  isFacial: false,
  // 字幕来源
  recognition_type: 'Vision',
  // 音色设置：1-音色克隆，2-单音色
  speech_type: 1,
  // 指定音色 id（单音色时必填）
  speech_id: undefined,
  // 开启硬字幕
  hard_subtitle_status: true,
  // 擦除原字幕
  erase_subtitle_status: true,
  // 保留BGM
  bgm_status: true
})

// 当前选中音色的试听 url
const selectedSpeechUrl = computed(() => {
  if (!formState.value.speech_id || !speechList.value.length) return null
  const item = speechList.value.find(s => s.id === formState.value.speech_id)
  return item?.url || null
})

// 试听：播放/停止（参考 Add.vue，支持暂停，切换新音色会先停止）
function audioPlayerPlay(url) {
  audioPlayerStop()
  if (!url) return
  const audio = new Audio(url)
  audioInstance.value = audio
  playingUrl.value = url
  audio.play().catch(() => {
    message.warning('播放失败')
    playingUrl.value = null
    audioInstance.value = null
  })
  audio.onended = () => {
    playingUrl.value = null
    audioInstance.value = null
  }
}
function audioPlayerStop() {
  if (audioInstance.value) {
    audioInstance.value.pause()
    audioInstance.value.currentTime = 0
    audioInstance.value = null
  }
  playingUrl.value = null
}
function touchPlayOrStop(url) {
  if (playingUrl.value === url) {
    audioPlayerStop()
  } else {
    audioPlayerPlay(url)
  }
}

// 音色类型切换：切到音色克隆时清空指定音色并停止试听
function onSpeechTypeChange() {
  if (formState.value.speech_type !== 2) {
    formState.value.speech_id = undefined
    audioPlayerStop()
  }
}

// 指定音色切换：停止当前试听
function onSpeechIdChange() {
  audioPlayerStop()
}

// 显示弹窗
function showDrawer(drama) {
  visible.value = true
  dramaDetail.value = drama || {}
  formState.value.lang_id = dramaDetail.value.lang_id
  // 获取选择项
  getSelectList()
}

// 语音翻译变化处理（二选一逻辑）
function handleVoiceChange(e) {
  if (e.target.checked) {
    formState.value.isFacial = false
  }
}

// 面容翻译变化处理（二选一逻辑）
function handleFacialChange(e) {
  if (e.target.checked) {
    formState.value.isVoice = false
  }
}

// 获取选择项
function getSelectList() {
  // 语种列表
  langSearchList().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
  // 发布账号列表
  accountAll().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      publishingAccountList.value = data
    }
  })
  // 音色列表（指定音色下拉用）
  speechAll().then(res => {
    const { code, data } = res
    if (code === 0 && Array.isArray(data)) {
      speechList.value = data
    } else {
      speechList.value = []
    }
  })
}

// 关闭弹窗
function onClose() {
  audioPlayerStop()
  visible.value = false
  // 关闭二次确认弹窗并清理
  handleConfirmCancel()
  pendingParams.value = null
  // 重置表单
  RefForm.value?.resetFields()
  dramaDetail.value = {}
  formState.value.lang_id = undefined
  formState.value.isSubtitle = true
  formState.value.isVoice = true
  formState.value.isFacial = false
  formState.value.recognition_type = 'OCR'
  formState.value.speech_type = 1
  formState.value.speech_id = undefined
  formState.value.hard_subtitle_status = true
  formState.value.erase_subtitle_status = true
  formState.value.bgm_status = true
}

// 提交（第一步：表单校验 + 组装参数 + 打开二次确认弹窗）
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 合成 translation_type_list
    const translation_type_list = []
    if (formState.value.isSubtitle) translation_type_list.push(VideoTranslationType.subtitle)
    if (formState.value.isVoice) translation_type_list.push(VideoTranslationType.voice)
    if (formState.value.isFacial) translation_type_list.push(VideoTranslationType.facial)
    
    // 验证至少选择一个翻译方式
    if (translation_type_list.length === 0) {
      message.warning('请至少选择一种翻译方式')
      return
    }
    
    // 单音色时必填指定音色
    if (formState.value.speech_type === 2 && !formState.value.speech_id) {
      message.warning('请选择指定音色')
      return
    }

    // 上传数据
    const params = {
      drama_id: dramaDetail.value.id,
      ...formState.value,
      translation_type_list: translation_type_list,
      speech_type: formState.value.speech_type,
      speech_id: formState.value.speech_type === 2 ? formState.value.speech_id : undefined,
      erase_subtitle_status: formState.value.erase_subtitle_status ? 1 : 0,
      hard_subtitle_status: formState.value.hard_subtitle_status ? 1 : 0,
      bgm_status: formState.value.bgm_status ? 1 : 0
    }

    // 移除临时字段
    delete params.isSubtitle
    delete params.isVoice
    delete params.isFacial

    // 记录待提交参数，打开二次确认弹窗
    pendingParams.value = params
    openConfirmModal()
  }).catch((err) => {
    console.log(err)
  })
}

// 打开二次确认弹窗并开始倒计时
function openConfirmModal() {
  confirmVisible.value = true
  confirmCountdown.value = 5
  confirmOkDisabled.value = true
  if (confirmTimer) {
    clearInterval(confirmTimer)
    confirmTimer = null
  }
  confirmTimer = setInterval(() => {
    if (confirmCountdown.value > 1) {
      confirmCountdown.value -= 1
    } else {
      confirmCountdown.value = 0
      confirmOkDisabled.value = false
      clearInterval(confirmTimer)
      confirmTimer = null
    }
  }, 1000)
}

// 关闭二次确认弹窗并清理倒计时
function handleConfirmCancel() {
  confirmVisible.value = false
  if (confirmTimer) {
    clearInterval(confirmTimer)
    confirmTimer = null
  }
  confirmCountdown.value = 5
  confirmOkDisabled.value = true
}

// 二次确认“确定”按钮：倒计时结束后才允许点击，真正发起任务检查和提交
function handleConfirmOk() {
  if (confirmOkDisabled.value) return
  handleConfirmCancel()
  if (!pendingParams.value) return
  doTaskCheckAndSubmit(pendingParams.value)
}

// 先检查任务是否存在，再真正提交任务
function doTaskCheckAndSubmit(params) {
  isLoading.value = true
  taskCheck(params).then((res) => {
    if (res.code === 0) {
      submitTask(params)
    } else if (res.code == -2) {
      isLoading.value = false
      Modal.confirm({
        title: '您选择的视频版本有视频缺失',
        content: '请在媒资管理中补齐',
        okText: '好的',
        cancelButtonProps: { style: { display: 'none' } }
      })
    } else if (res.code == -3) {
      Modal.confirm({
        title: '该剧创建过同类任务噢',
        content: '你确定再次翻译吗？',
        okText: '确定',
        cancelText: '再想想',
        onOk: () => {
          submitTask(params)
        },
        onCancel: () => {
          isLoading.value = false
        }
      })
    } else {
      isLoading.value = false
      message.error(res.message)
    }
  }).catch(() => {
    isLoading.value = false
    message.error('检查失败')
  })
}

// 提交任务
function submitTask(params) {
  taskSave(params).then((res) => {
    isLoading.value = false
    if (res.code === 0) {
      message.success('提交成功')
      onClose()
      emit('success')
    }
  }).catch(() => {
    isLoading.value = false
    message.error('提交失败')
  })
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
.timbre-preview-link {
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
}
</style>
